import React, { ChangeEvent } from 'react';
import { TextField, Typography, IconButton, InputAdornment } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';

const useStyles = makeStyles({
  action: {
    //
  },
  arrowBackIcon: {
    position: 'absolute',
    top: 10,
    left: 10,
  },
  inputContainer: {
    margin: '30px 0 60px',
  },
});

interface PasswordStepProps {
  login: {
    name: string;
    email: string;
    password: string;
  };
  handleChange(e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void;
  handleStepBack(): void;
  shownPassword: boolean;
  handlePasswordVisibility(): void;
  loading: boolean;
}

const PasswordStep: React.FC<PasswordStepProps> = ({
  login,
  handleChange,
  handleStepBack,
  shownPassword,
  handlePasswordVisibility,
  loading,
}) => {
  const classes = useStyles();

  return (
    <>
      <IconButton className={classes.arrowBackIcon} onClick={handleStepBack}>
        <ArrowBackIcon />
      </IconButton>
      <Typography align="center" variant="body2" color="textSecondary">
        Seja bem-vindo {login.name}.
      </Typography>
      <div className={classes.inputContainer}>
        <input type="text" autoComplete="username email" value={login.email} style={{ display: 'none' }} />
        <TextField
          label="Senha"
          placeholder="Informe sua senha"
          fullWidth
          value={login.password}
          onChange={loading ? undefined : handleChange}
          name="password"
          type={shownPassword ? 'text' : 'password'}
          autoFocus
          required
          autoComplete="current-password"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {shownPassword ? (
                  <VisibilityOffIcon color="primary" onClick={handlePasswordVisibility} />
                ) : (
                  <VisibilityIcon color="primary" onClick={handlePasswordVisibility} />
                )}
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );
};

export default PasswordStep;
